import { Clickable, H3, Modal, SpacerWrapper } from '@ahmdigital/ui';
import styled from 'styled-components';

import BasicDetailsForm, { BasicDetailsFormProps } from '../basic-details-form';

const ModalContent = styled.div`
  padding: 1rem;

  @media (min-width: ${({ theme }) => theme.media.lg}) {
    max-width: 26rem;
  }
`;

const SkipThisWrapper = styled(SpacerWrapper)`
  display: flex;
  justify-content: center;
`;

const SkipThis = styled(Clickable)`
  font-weight: 800;
`;

type BasicDetailsModalProps = {
  form: BasicDetailsFormProps;
  isOpen?: boolean;
  toggleModal: (...args: unknown[]) => unknown;
};

const BasicDetailsModal = ({ form, isOpen = true, toggleModal }: BasicDetailsModalProps) => {
  const { handleSubmit, defaultValues } = form;

  return (
    <Modal ariaLabelledBy="basic-details-modal-title" isOpen={isOpen} toggleModal={toggleModal}>
      <ModalContent>
        <SpacerWrapper variant="marginBottomSpacer9">
          <H3 id="basic-details-modal-title">Show me choosable extra covers for...</H3>
        </SpacerWrapper>
        <BasicDetailsForm defaultValues={defaultValues} handleSubmit={handleSubmit} />
        <SkipThisWrapper variant={['marginBottomSpacer9', 'marginTopSpacer9']}>
          <SkipThis onClick={toggleModal}>Skip this</SkipThis>
        </SkipThisWrapper>
      </ModalContent>
    </Modal>
  );
};

export default BasicDetailsModal;
